/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * logicomix-api
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import type {
  GetApiUsers200Item,
  GetApiUsersId200,
  GetApiUsersMe200,
  PatchApiUsersIdRolesApiBodies,
  PatchApiUsersIdScopesApiBodies,
  PostApiUsers200,
  PostApiUsersApiBodies,
  PostApiUsersResetPassword200,
  PostApiUsersResetPasswordApiBodies,
  PostApiUsersResetPasswordConfirmation201,
  PostApiUsersResetPasswordConfirmationApiBodies
} from './Api.schemas'
import { customInstance } from '../AxiosInstance';
import type { ErrorType } from '../AxiosInstance';




export const getApiUsersMe = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetApiUsersMe200>(
      {url: `/api/users/me`, method: 'GET', signal
    },
      );
    }
  

export const getGetApiUsersMeQueryKey = () => {
    return [`/api/users/me`] as const;
    }

    
export const getGetApiUsersMeQueryOptions = <TData = Awaited<ReturnType<typeof getApiUsersMe>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiUsersMe>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiUsersMeQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiUsersMe>>> = ({ signal }) => getApiUsersMe(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiUsersMe>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiUsersMeQueryResult = NonNullable<Awaited<ReturnType<typeof getApiUsersMe>>>
export type GetApiUsersMeQueryError = ErrorType<unknown>

export const useGetApiUsersMe = <TData = Awaited<ReturnType<typeof getApiUsersMe>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiUsersMe>>, TError, TData>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetApiUsersMeQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getApiUsers = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetApiUsers200Item[]>(
      {url: `/api/users`, method: 'GET', signal
    },
      );
    }
  

export const getGetApiUsersQueryKey = () => {
    return [`/api/users`] as const;
    }

    
export const getGetApiUsersQueryOptions = <TData = Awaited<ReturnType<typeof getApiUsers>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiUsers>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiUsersQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiUsers>>> = ({ signal }) => getApiUsers(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiUsers>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiUsersQueryResult = NonNullable<Awaited<ReturnType<typeof getApiUsers>>>
export type GetApiUsersQueryError = ErrorType<unknown>

export const useGetApiUsers = <TData = Awaited<ReturnType<typeof getApiUsers>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiUsers>>, TError, TData>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetApiUsersQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const postApiUsers = (
    postApiUsersApiBodies: PostApiUsersApiBodies,
 ) => {
      
      
      return customInstance<PostApiUsers200>(
      {url: `/api/users`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postApiUsersApiBodies
    },
      );
    }
  


export const getPostApiUsersMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiUsers>>, TError,{data: PostApiUsersApiBodies}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiUsers>>, TError,{data: PostApiUsersApiBodies}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiUsers>>, {data: PostApiUsersApiBodies}> = (props) => {
          const {data} = props ?? {};

          return  postApiUsers(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiUsersMutationResult = NonNullable<Awaited<ReturnType<typeof postApiUsers>>>
    export type PostApiUsersMutationBody = PostApiUsersApiBodies
    export type PostApiUsersMutationError = ErrorType<unknown>

    export const usePostApiUsers = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiUsers>>, TError,{data: PostApiUsersApiBodies}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof postApiUsers>>,
        TError,
        {data: PostApiUsersApiBodies},
        TContext
      > => {

      const mutationOptions = getPostApiUsersMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const getApiUsersId = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetApiUsersId200>(
      {url: `/api/users/${id}`, method: 'GET', signal
    },
      );
    }
  

export const getGetApiUsersIdQueryKey = (id: string,) => {
    return [`/api/users/${id}`] as const;
    }

    
export const getGetApiUsersIdQueryOptions = <TData = Awaited<ReturnType<typeof getApiUsersId>>, TError = ErrorType<unknown>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiUsersId>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiUsersIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiUsersId>>> = ({ signal }) => getApiUsersId(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiUsersId>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiUsersIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiUsersId>>>
export type GetApiUsersIdQueryError = ErrorType<unknown>

export const useGetApiUsersId = <TData = Awaited<ReturnType<typeof getApiUsersId>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiUsersId>>, TError, TData>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetApiUsersIdQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const patchApiUsersIdRoles = (
    id: string,
    patchApiUsersIdRolesApiBodies: PatchApiUsersIdRolesApiBodies,
 ) => {
      
      
      return customInstance<void>(
      {url: `/api/users/${id}/roles`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchApiUsersIdRolesApiBodies
    },
      );
    }
  


export const getPatchApiUsersIdRolesMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiUsersIdRoles>>, TError,{id: string;data: PatchApiUsersIdRolesApiBodies}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchApiUsersIdRoles>>, TError,{id: string;data: PatchApiUsersIdRolesApiBodies}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchApiUsersIdRoles>>, {id: string;data: PatchApiUsersIdRolesApiBodies}> = (props) => {
          const {id,data} = props ?? {};

          return  patchApiUsersIdRoles(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchApiUsersIdRolesMutationResult = NonNullable<Awaited<ReturnType<typeof patchApiUsersIdRoles>>>
    export type PatchApiUsersIdRolesMutationBody = PatchApiUsersIdRolesApiBodies
    export type PatchApiUsersIdRolesMutationError = ErrorType<unknown>

    export const usePatchApiUsersIdRoles = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiUsersIdRoles>>, TError,{id: string;data: PatchApiUsersIdRolesApiBodies}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof patchApiUsersIdRoles>>,
        TError,
        {id: string;data: PatchApiUsersIdRolesApiBodies},
        TContext
      > => {

      const mutationOptions = getPatchApiUsersIdRolesMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const patchApiUsersIdScopes = (
    id: string,
    patchApiUsersIdScopesApiBodies: PatchApiUsersIdScopesApiBodies,
 ) => {
      
      
      return customInstance<void>(
      {url: `/api/users/${id}/scopes`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchApiUsersIdScopesApiBodies
    },
      );
    }
  


export const getPatchApiUsersIdScopesMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiUsersIdScopes>>, TError,{id: string;data: PatchApiUsersIdScopesApiBodies}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchApiUsersIdScopes>>, TError,{id: string;data: PatchApiUsersIdScopesApiBodies}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchApiUsersIdScopes>>, {id: string;data: PatchApiUsersIdScopesApiBodies}> = (props) => {
          const {id,data} = props ?? {};

          return  patchApiUsersIdScopes(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchApiUsersIdScopesMutationResult = NonNullable<Awaited<ReturnType<typeof patchApiUsersIdScopes>>>
    export type PatchApiUsersIdScopesMutationBody = PatchApiUsersIdScopesApiBodies
    export type PatchApiUsersIdScopesMutationError = ErrorType<unknown>

    export const usePatchApiUsersIdScopes = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiUsersIdScopes>>, TError,{id: string;data: PatchApiUsersIdScopesApiBodies}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof patchApiUsersIdScopes>>,
        TError,
        {id: string;data: PatchApiUsersIdScopesApiBodies},
        TContext
      > => {

      const mutationOptions = getPatchApiUsersIdScopesMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const postApiUsersResetPassword = (
    postApiUsersResetPasswordApiBodies: PostApiUsersResetPasswordApiBodies,
 ) => {
      
      
      return customInstance<PostApiUsersResetPassword200>(
      {url: `/api/users/reset-password`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postApiUsersResetPasswordApiBodies
    },
      );
    }
  


export const getPostApiUsersResetPasswordMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiUsersResetPassword>>, TError,{data: PostApiUsersResetPasswordApiBodies}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiUsersResetPassword>>, TError,{data: PostApiUsersResetPasswordApiBodies}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiUsersResetPassword>>, {data: PostApiUsersResetPasswordApiBodies}> = (props) => {
          const {data} = props ?? {};

          return  postApiUsersResetPassword(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiUsersResetPasswordMutationResult = NonNullable<Awaited<ReturnType<typeof postApiUsersResetPassword>>>
    export type PostApiUsersResetPasswordMutationBody = PostApiUsersResetPasswordApiBodies
    export type PostApiUsersResetPasswordMutationError = ErrorType<unknown>

    export const usePostApiUsersResetPassword = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiUsersResetPassword>>, TError,{data: PostApiUsersResetPasswordApiBodies}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof postApiUsersResetPassword>>,
        TError,
        {data: PostApiUsersResetPasswordApiBodies},
        TContext
      > => {

      const mutationOptions = getPostApiUsersResetPasswordMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const postApiUsersResetPasswordConfirmation = (
    postApiUsersResetPasswordConfirmationApiBodies: PostApiUsersResetPasswordConfirmationApiBodies,
 ) => {
      
      
      return customInstance<PostApiUsersResetPasswordConfirmation201>(
      {url: `/api/users/reset-password-confirmation`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postApiUsersResetPasswordConfirmationApiBodies
    },
      );
    }
  


export const getPostApiUsersResetPasswordConfirmationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiUsersResetPasswordConfirmation>>, TError,{data: PostApiUsersResetPasswordConfirmationApiBodies}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiUsersResetPasswordConfirmation>>, TError,{data: PostApiUsersResetPasswordConfirmationApiBodies}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiUsersResetPasswordConfirmation>>, {data: PostApiUsersResetPasswordConfirmationApiBodies}> = (props) => {
          const {data} = props ?? {};

          return  postApiUsersResetPasswordConfirmation(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiUsersResetPasswordConfirmationMutationResult = NonNullable<Awaited<ReturnType<typeof postApiUsersResetPasswordConfirmation>>>
    export type PostApiUsersResetPasswordConfirmationMutationBody = PostApiUsersResetPasswordConfirmationApiBodies
    export type PostApiUsersResetPasswordConfirmationMutationError = ErrorType<unknown>

    export const usePostApiUsersResetPasswordConfirmation = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiUsersResetPasswordConfirmation>>, TError,{data: PostApiUsersResetPasswordConfirmationApiBodies}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof postApiUsersResetPasswordConfirmation>>,
        TError,
        {data: PostApiUsersResetPasswordConfirmationApiBodies},
        TContext
      > => {

      const mutationOptions = getPostApiUsersResetPasswordConfirmationMutationOptions(options);

      return useMutation(mutationOptions);
    }
    